import * as _ from 'lodash';

import axiosInstance from '../../../axiosInstance';

export const sendOtpSms = async (payload: {
  accessToken: string,
  data: {
    phoneNumber: {
      countryCode: string,
      number: string
    }
  },
}, { dispatch }) => {
  try {
    const res = await axiosInstance.post(
      `otp/newSendSms`,
      {
        ...payload?.data
      },
      {
        headers: {
          Authorization: `Bearer ${payload.accessToken}`
        }
      }
    );
    return res.data;
  } catch (err) {
    throw new Error(
      err?.response?.data?.msg ||
      'An error occurred while sending OTP.'
    );
  }
};

export const verifyOtpSms = async (payload: {
  accessToken: string,
  data: {
    otp: string,
    username: string,
    otpToken: string,
    mobileNo: string,
    rememberDevice?: boolean,
  },
}, { dispatch }) => {
  try {
    const res = await axiosInstance.post(
      `otp/newVerify`,
      {
        ...payload?.data
      },
      {
        headers: {
          Authorization: `Bearer ${payload.accessToken}`
        }
      }
    );
    return res.data;
  } catch (err) {
    throw new Error(
      err?.response?.data?.msg ||
      'An error occurred while verifying OTP.'
    );
  }
};
